import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getCalificacion'
})
export class GetCalificacionPipe implements PipeTransform {

  transform(id_actividad:any , id_user: any,  todos_cursos:any): any {
    let calificacion =0; 
    if(todos_cursos){
      let activity = todos_cursos.find((x:any)=> {
          if(x.calificacion && x.calificacion.length>0 && x.calificacion[0].id_actividad == id_actividad && x.calificacion[0].id_user == id_user){
            return x;
          }
      });
      if(activity){
        calificacion = activity.calificacion[0].totalCalificacion
      }
    }
    return calificacion;
  }

}
